import React, { useState } from "react";
import { useDispatch } from "react-redux";
import GridTable from "pages/_components/GridTable/GridTable";
import SwitchField from "pages/_components/fields/SwitchField";
import classNames from "classnames";
import CustomData from "pages/_components/CustomData/CustomData";
import { shape, bool } from "prop-types";
import * as i18n from "util/i18n";
import { routerActions } from "connected-react-router";
import { actions as debinActions } from "reducers/debin";
import Notification from "pages/_components/Notification";

const DebinListElement = ({ account, switchInitialState }) => {
    const [switchState, setSwitchState] = useState(switchInitialState);
    const dispatch = useDispatch();

    const maskAccountNumber = (accountNumber) => {
        const mask = "****";
        if (accountNumber) {
            return mask + accountNumber.slice(-4);
        }
        return mask;
    };

    const onChangeSwitchStatus = () => {
        if (switchState) {
            dispatch(debinActions.removeVendorAccount({ idAccount: account?.productId }));
        } else {
            dispatch(routerActions.push(`addAccount/${account?.productId}`));
        }

        setSwitchState(!switchState);
    };

    return (
        <GridTable className={classNames("products-list")}>
            <Notification scopeToShow="removeVendorAccountDebin" />
            <GridTable.Container rowId={account?.productId} columns={4} rows={1} key={account?.productId}>
                <GridTable.Data
                    key={account?.productId}
                    columnStart={1}
                    rowStart={1}
                    alignX="flex-start"
                    alignY="flex-start">
                    <SwitchField
                        name={account?.productId}
                        key={account?.productId}
                        hideLabel
                        value={switchState}
                        onChange={onChangeSwitchStatus}
                    />
                </GridTable.Data>
                <GridTable.Data
                    key={account?.productId}
                    columnStart={2}
                    rowStart={1}
                    alignX="flex-start"
                    alignY="flex-start">
                    <CustomData
                        titleText="debin.addAccount.name"
                        titleTextType="I18N"
                        valueText={`№${maskAccountNumber(account?.accountNumber)}`}
                    />
                </GridTable.Data>
                <GridTable.Data
                    key={account?.productId}
                    columnStart={3}
                    rowStart={1}
                    alignX="flex-start"
                    alignY="flex-start">
                    <CustomData
                        titleText="debin.add.type"
                        titleTextType="I18N"
                        valueText={`${i18n.get(`accounts.accountType.${account?.accountType}`)}`}
                    />
                </GridTable.Data>
                <GridTable.Data
                    key={account?.productId}
                    columnStart={4}
                    rowStart={1}
                    alignX="flex-start"
                    alignY="flex-start">
                    <CustomData titleText="debin.add.currency" titleTextType="I18N" valueText={account?.currency} />
                </GridTable.Data>
            </GridTable.Container>
        </GridTable>
    );
};

DebinListElement.defaultProps = {};

DebinListElement.propTypes = {
    account: shape({}).isRequired,
    switchInitialState: bool.isRequired,
};

export default DebinListElement;
